import { IllustrationHouseMissing } from '@bbl-digital/snorre'
import { Button } from '@bbl-digital/snorre-v2'
import { useAuth } from 'Auth/shared/hooks/useAuth'
import React from 'react'
import {
  ERROR_IS_NOT_AUTHENTICATED,
  ERROR_NO_AUTHORIZATION,
  ERROR_NO_AUTHORIZATION_NO_CLIENT,
} from 'shared/constants/errorMessages'
import { getBblSettings } from 'shared/store/bbl/selectors'
import { getActiveClient } from 'shared/store/clients/selectors'
import { useAppSelector } from 'shared/store/store'
import { Wrapper } from './styles'
import NoResults from '../NoResults'

interface IProps {
  authenticationError?: boolean
  showLogOut?: boolean
}

const NotAuthorizedPage: React.FC<IProps> = ({
  authenticationError,
  showLogOut,
}) => {
  const authContext = useAuth()
  const client = useAppSelector(getActiveClient)
  const bblSettings = useAppSelector(getBblSettings)

  const handleLogout = () => {
    authContext.signOutRedirect({
      bbl_redirect: bblSettings?.afterLogoutRedirectUrl || '',
      post_logout_redirect_uri: window.location.origin + '/portal/afterlogout',
    })
  }

  const messsage = authenticationError
    ? ERROR_IS_NOT_AUTHENTICATED
    : client
      ? ERROR_NO_AUTHORIZATION(client.clientName)
      : ERROR_NO_AUTHORIZATION_NO_CLIENT

  return (
    <Wrapper>
      <NoResults illustration={<IllustrationHouseMissing />} text={messsage} />
      {showLogOut && <Button onClick={handleLogout}>Logg ut</Button>}
    </Wrapper>
  )
}

export default NotAuthorizedPage
